import { ApplicationConfig, enableProdMode } from '@angular/core';

import 'hammerjs';

import { environment } from '@environment';
import { AppComponent } from '../../../src/app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '../src/app/app.config';
import { browserConfig } from 'src/browser.config';

if (environment.NODE_ENV === 'production') {
    enableProdMode();
}

const options: ApplicationConfig = {
    ...appConfig,
    providers: [
        ...appConfig.providers,
        ...browserConfig.providers
    ]
};

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(AppComponent, options)
        .then(() => {
            if ('serviceWorker' in navigator) {
                navigator.serviceWorker.register('./firebase-messaging-sw.js').then(
                    _registration => {
                        console.log('Service worker registration succeeded');
                    },
                    error => {
                        console.log(`Service worker registration failed: ${error}`);
                    }
                );
            }
        })
        .catch(err => console.log(err));
});
console.log(`
    ██████╗░░█████╗░██╗░░██╗░█████╗░
    ██╔══██╗██╔══██╗╚██╗██╔╝██╔══██╗
    ██████╦╝██║░░██║░╚███╔╝░╚█████╔╝
    ██╔══██╗██║░░██║░██╔██╗░██╔══██╗
    ██████╦╝╚█████╔╝██╔╝╚██╗╚█████╔╝
    ╚═════╝░░╚════╝░╚═╝░░╚═╝░╚════╝░
`);
console.log(
    "%cHey Geek! Wanna be part of India's fastest growing food-tech startup?\n\nApply now at " + 'https://box8.recruitee.com',
    'color: blue'
);
